import React from "react";

function SDGIcon({ imageUrl, bars, format = "bottom-bars", iconWidth = 140 }) {
  const iconHeight = iconWidth;
  const iconMarginRight = 10;
  const iconMarginBottom = 10;
  return (
    <div
      style={{
        position: "relative",
        width: iconWidth,
        height: iconHeight,
        marginRight: iconMarginRight,
        marginBottom: iconMarginBottom,
      }}
    >
      <img
        className="ahp-sustainability-img"
        src={imageUrl}
        alt="Sustainability icon"
        width={iconWidth}
        // padding="0px"
        // margin="0px"
      />
      <div
        className="ahp-battery-contour"
        style={{
          border: "1px solid lightgrey",
          height: iconHeight + iconHeight * 0.25,
          width: iconWidth,
        }}
      >
        {format === "bottom-bars" &&
          [...Array(bars).keys()].map((a, i) => (
            <div
              style={{
                position: "absolute",
                width: iconWidth / 6,
                height: iconHeight / 5,
                marginLeft: iconWidth / 12 + (iconWidth / 5) * i,
                marginRight: iconWidth / 24,
                marginTop: 1 * iconHeight,
                backgroundColor: "limegreen",
                border: "1px solid limegreen",
              }}
              key={i}
            ></div>
          ))}
      </div>

      {format === "right-bars" &&
        [...Array(bars).keys()].map((a, i) => (
          <div
            style={{
              position: "absolute",
              width: iconWidth / 20,
              height: iconHeight / 6,
              marginLeft: 0.92 * iconWidth,
              marginRight: iconWidth / 24,
              marginTop: 0.67 * iconHeight - (iconHeight / 5) * (bars - 1 - i),
              backgroundColor: "white",
            }}
            key={i}
          ></div>
        ))}
    </div>
  );
}

export default SDGIcon;
